import {
  FILE_TYPES,
  FileTypes,
} from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';

// percentage
export const PERCENTRAGE = '%';
export const MAX_PERCENTAGE = 100;
export const MAX_PERCENTAGE_TEXT = `${MAX_PERCENTAGE}${PERCENTRAGE}`;

// currency
export const DOLLAR = '$';

// params
export const FIRST_PAGE = '1';
export const EMPTY_ARRAY_STRINGIFIED = '[]';
export const MAX_LIMIT = '99999';
export const DEFAULT_LIMIT = '50';

export const MAX_VALUE = Infinity;

// position
export const INITIAL_POSITION = { left: 0, top: 0 };

export const DEBOUNCE_TIME = 250;
export const TRANSITION_TIME = 330;
export const FIVE_SECONDS = 5000;
export const MINUTE = 60000; // 60 * 1000ms

export const SMOOTH_SCROLL_CONFIGURATION = {
  behavior: 'smooth',
} as ScrollToOptions;

export const START_SCROLL_CONFIGURATION = {
  top: 0,
  left: 0,
} as ScrollToOptions;

// tags
export const DEFAULT_TAG = '@';

// fields
export const NAME_MAX_LENGTH = 50;

// file
export const ONE_KB = 1024;
export const ONE_MB = ONE_KB * 1024;
export const ONE_GB = ONE_MB * 1024;
export const SINGLE_FILE_MAX_SIZE_MB = 10;
export const SINGLE_FILE_MAX_SIZE_DIRECT_UPLOAD =
  SINGLE_FILE_MAX_SIZE_MB * ONE_MB;

export const SINGLE_FILE_MAX_SIZE_GB = 15;
export const SINGLE_FILE_MAX_SIZE = SINGLE_FILE_MAX_SIZE_GB * ONE_GB;

export const DATA_ROOM_MAX_STORAGE = 50;
export const DATA_ROOM_MAX_STORAGE_GB = DATA_ROOM_MAX_STORAGE * ONE_GB;

export const MAX_BATCH_SIZE_GB = 50;
export const MAX_BATCH_SIZE = MAX_BATCH_SIZE_GB * ONE_GB;

// links
export const NEW_WINDOW_PROPS = { target: '_blank', rel: 'noreferrer' };

export const EDIT_ROUTE = 'edit';

export const AUTH_ROUTE = '/auth';

export const LOGIN_ROUTE = `${AUTH_ROUTE}/login`;
export const SIGNUP_ROUTE = `${AUTH_ROUTE}/sign-up`;
export const RESET_PASSWORD_ROUTE = `${AUTH_ROUTE}/reset-password`;
export const SOCIAL_LOGIN_ROUTE = `${AUTH_ROUTE}/social-login`;
export const FORGOT_PASSWORD_ROUTE = `${AUTH_ROUTE}/forgot-password`;
export const TWO_FA_ROUTE = `${AUTH_ROUTE}/2-fa`;

export const CONTACT_US_ROUTE = '/contact-us';

export const GLOBAL_MESSAGING = '/dash/messaging';

export const ADMIN_DASHBOARD_ROUTE = '/dash/admin-dashboard';
export const ADMIN_DASHBOARD_SPONSORED_ROUTE = `${ADMIN_DASHBOARD_ROUTE}/sponsored-adverts`;
export const ADMIN_DASHBOARD_BROKER_LIST_ROUTE = `${ADMIN_DASHBOARD_ROUTE}/broker-list`;
export const ADMIN_DASHBOARD_BOSS_MODE_FORENSICS = `${ADMIN_DASHBOARD_ROUTE}/boss-mode-stats/forensics`;
export const ADMIN_DASHBOARD_BOSS_MODE_SUGGESTED_ACTIONS = `${ADMIN_DASHBOARD_ROUTE}/boss-mode-stats/suggested-actions`;
export const ADMIN_DASHBOARD_LISTING_METRICS_ROUTE = `${ADMIN_DASHBOARD_ROUTE}/listing-metrics`;
export const ADMIN_DASHBOARD_ACTIVITY_METRICS_ROUTE = `${ADMIN_DASHBOARD_ROUTE}/activity-metrics`;
export const ADMIN_DASHBOARD_ENTERPRISE_ROUTE = `${ADMIN_DASHBOARD_ROUTE}/enterprise`;
export const ADMIN_DASHBOARD_EDIT_PROFILE = `${ADMIN_DASHBOARD_ROUTE}/edit-profile`;
export const ADMIN_DASHBOARD_BOSS_MODE_ACCOUNTS = `${ADMIN_DASHBOARD_ROUTE}/boss-mode-accounts`;

export const BUSINESS_ROUTE = '/business';
export const URGENT_ROUTE = '/urgent';

export const CONTACTS_ROUTE = '/dash/contacts';

export const MESSAGING_ROUTE = '/messaging';

export const NOTIFICATIONS_ROUTE = '/dash/notifications';

export const CREATE_DEAL_ROUTE = '/dash/create-deal';
export const EDIT_DEAL_ROUTE = '/dash/edit-deal';

export const ENTERPRISE_ROUTE = '/dash/enterprise';

export const LCW_BASE_ROUTE = '/dash/create-business';

export const SEARCH_ROUTE = '/search';

export const RWC_ROUTE = '/RWC';

export const VENDOR_QUALIFICATION_ROUTE = '/vendor-qualification';

export const ONBOARD_ENTERPRISE_ROUTE = '/onboard-enterprise-member';

export const ETAFORUM_ROUTE = '/etaforum';

export const PRIVATE_LISTING_ROUTE = '/private-listing-landing';

export const ACCOUNTANT_ROUTE = '/accountant';

export const PREMIUM_BUYER_SUBSCRIPTION_ROUTE = '/premium-buyer-subscription';

export const CONFIDENTIALITY_AGREEMENT_ROUTE =
  '/dash/confidentiality-agreement';

export const INVESTOR_VERIFICATION_ROUTE =
  '/dash/investor-verification-preview';

export const EMAIL_VERIFICATION = 'email-verification';
export const DOCUSIGN_URL = 'docusign-url';
export const MAGIC_LINK = 'magic-link';
export const SEND_PASSWORD_FOR_SHAREABLE_LINK =
  'send-password-for-shareable-link';

// profile
export const PERSONAL_DETAILS = 'personal-details';
export const BASE_PROFILE_ROUTE = '/dash/profile/edit';
export const PROFILE_ROUTE = `${BASE_PROFILE_ROUTE}/profile`;
export const PROFILE_PERSONAL_DETAILS_ROUTE = `${BASE_PROFILE_ROUTE}/${PERSONAL_DETAILS}`;
export const PROFILE_ACCOUNT = `${BASE_PROFILE_ROUTE}/account`;

// portfolio
export const PORTFOLIO_ROUTE = '/dash/portfolio';
export const BOSS_MODE_LABEL = 'brokerManaged';
export const BOSS_MODE_PATH = 'boss-mode';
export const SELLER_PATH = 'selling';
export const SELLER_LABEL = 'selling';
export const BUYING_PATH = 'buying';
export const BUYING_LABEL = 'buying';

export const SELLING_PORTFOLIO_ROUTE = `${PORTFOLIO_ROUTE}/${SELLER_PATH}`;
export const BUYING_PORTFOLIO_ROUTE = `${PORTFOLIO_ROUTE}/${BUYING_PATH}`;
export const WATCHLIST_PORTFOLIO_ROUTE = `${BUYING_PORTFOLIO_ROUTE}/watchlist`;

export const DEAL_ROUTE = '/deal';
export const LEADS_ROUTE = '/leads';
export const LISTING_INFORMATION_ROUTE = '/listing-information';
export const SETTINGS_ENGUIRE_ROUTE = '/settings/enquire';
export const SETTINGS_ACCEPT_ROUTE = '/settings/accept';
export const SETTINGS_PROSPECT_ROUTE = '/settings/confirm';
export const SETTINGS_BIDDER_ROUTE = '/settings/offer';
export const QUALIFICATION_QUESTIONS = '/qualification-questions';
export const BUYING_PROFILE_ROUTE = '/profile';

export const DATA_ROOM_ROUTE = '/dash/data-room';
export const DASHBOARD_DR_ROUTE = '/dashboard';
export const DOCUMENTS_DR_ROUTE = '/documents';
export const QANDA_DR_ROUTE = '/questions/questions-and-answers';
export const FAQ_DR_ROUTE = '/questions/frequently-asked-questions';
export const MEMBERS_DR_ROUTE = '/members';
export const WAITING_ROOM_DR_ROUTE = '/waiting-room';
export const RFI_DR_ROUTE = '/rfi';
export const REPORTS_OVERWIEW_DR_ROUTE = '/reports/overview';
export const REPORTS_LOG_DR_ROUTE = '/reports/activity-log';
export const NDAS_DR_ROUTE = '/ndas';
export const SETTINGS_DR_ROUTE = '/settings';

// shareable links
export const SHAREABLE_LINKS_ROUTE = '/shareable-links';

export const LCW_BUSINESS_INFO_ROUTE = 'default/business-info';
export const LCW_STATEMENT_OF_INFORMATION_ROUTE =
  'default/statement-of-information';
export const LCW_LISTING_OPTIONS_ROUTE = 'default/listing-options';
export const LCW_MEDIA_PACKAGE_ROUTE = 'default/media-package';
export const LCW_CHECKOUT_ROUTE = 'default/checkout';

export const LCW_ROUTE_PATHS = [
  LCW_BUSINESS_INFO_ROUTE,
  LCW_STATEMENT_OF_INFORMATION_ROUTE,
  LCW_LISTING_OPTIONS_ROUTE,
  LCW_MEDIA_PACKAGE_ROUTE,
  LCW_CHECKOUT_ROUTE,
] as const;

export const RFI_LINK = '/filevault';

export const OPEN_ENQUIRY_HASH = '#openEnquire';
export const OPEN_DEAL_STATUS_HASH = '#openDealStatus';

export const OPEN_FAQ_DRAWER_PARAM = 'newFaq';

export const ESCAPE_KEY = 'Escape';
export const ENTER_KEY = 'Enter';
export const TAB_KEY = 'Tab';
export const SHIFT_KEY = 'Shift';
export const META_KEY = 'Meta';
export const CONTROL_KEY = 'Control';
export const SPACE_KEY = 'Space';
export const COMMA_KEY = 'Comma';
export const SEMICOLON_KEY = 'Semicolon';
export const ARROW_DOWN_KEY = 'ArrowDown';
export const ARROW_UP_KEY = 'ArrowUp';
export const ARROW_LEFT_KEY = 'ArrowLeft';
export const ARROW_RIGHT_KEY = 'ArrowRight';

export const MAP_MAPBOX_STYLES = 'mapbox://styles/mapbox/streets-v12';

export const VERIFIED_PIN_ID = 'VERIFIED_PIN_ID';

export const GENERAL_BM_ACCOUNT = 'listings@resolve.com.au';

export const MULTI_SORT_SEPARATOR = ' ';

export const DATA_ROOM_ROOT_FOLDER = 'home';

// file types

export const EXCEL_FILE_TYPES: FileTypes[] = [
  FILE_TYPES.DOCUMENT_XLS,
  FILE_TYPES.DOCUMENT_XLSX,
];

export const SHEET_FILE_TYPES: FileTypes[] = [
  ...EXCEL_FILE_TYPES,
  FILE_TYPES.DOCUMENT_CSV,
];

export const WORD_FILES: FileTypes[] = [
  FILE_TYPES.DOCUMENT_DOC,
  FILE_TYPES.DOCUMENT_DOCX,
];

export const DOCUMENT_FILES: FileTypes[] = [...WORD_FILES, FILE_TYPES.PDF];

export const POWERPOINT_FILES: FileTypes[] = [
  FILE_TYPES.DOCUMENT_PPT,
  FILE_TYPES.DOCUMENT_PPTX,
];

export const DATA_ROOM_INPUT_ID = 'res-data-room-upload-input';

export const PAGE_PARAM_KEYWORD = 'page';
export const SORT_PARAM_KEYWORD = 'sort';
export const LIMIT_PARAM_KEYWORD = 'limit';
export const TIMEFRAME_PARAM_KEYWORD = 'timeframe';

export const REQUIRED_VISIBLE_INFO = 'RequiredVisibleInfo';
